export default {
  // logo: "Yuxin Gene",
  logo: "Sinochrome",

  common: {
    welcome: "Welcome",
    about: "About Us",
    contact: "Contact",
    newCenter: "News Center",
    instrument: "Instrument",
    home: 'Home',
    product: 'Products',
    solution: 'Solutions',
    newsCenter: 'News Center',
    Documents: 'Documents',
    Certificattion: 'Certificattion',
    ApplicationNotes: 'Application Notes',
    Publications: 'Publications',
    SafetyDataSheets: 'Safety Data Sheets',
    aboutUs: 'About Us',
    joinUs: 'Join Us',
    contactUs: 'Contact Us',
    recruitment: 'Recruitment',
    companyNews: 'Company News',
    industryNews: 'Industry News',
    name: 'Name',
    collaboration: 'Scientific Collaboration',
    achievements: 'Research Achievements',
  },

  homePage: {
    ourServices: 'Our Services',
    newsCenter: 'News Center',
    viewMore: 'View More',
    viewDetails: 'View Details'
  },

  InstrumentPage: {
    relatedVideos: 'Videos',
    useCases: 'Use Cases',
    downloadMaterials: 'Product Materials',
    preview: 'Preview',
    download: 'Download',
    previewPDFOnly: 'Preview PDF Only',
  },

  AboutUs: {
    companyVision: 'Company Vision',
    companyProfile: 'Company Profile',
    about1: 'About SinoChrome',
    about2: 'Mission Vision',
    about3: 'Honor Qualification',
    about4: 'Scientific Collaboration',
    about5: 'Research Achievements',
    about6: 'User Representatives',
  },

  Footer: {
    companyAddress: 'Company Address',
    phone: 'Phone',
    num1: '+86-21-56670577',
    num2: '+86-400-0021-908',
    email: 'Email',
    allRightsReserved: 'All Rights Reserved',
    fullAddress: 'No. 99, Third Building, Fuliand 3 Road, Baoshan District, Shanghai',
    instrument: "Instrument",
    reagent: 'Reagent',
    software: 'Software',
    aboutUs: 'About Us',
    contactUs: 'Contact Us',
    recruitment: 'Join US',
    logoName: 'sinochrome',
    // name: 'Shanghai Yuxin Gene Technology Co., Ltd.'
    name: 'Shanghai Sionchrome Technology Co., Ltd.',
    ProductOrdering: 'Product Ordering',
    CorporateWeChatAccount: 'Corporate WeChat',
  },

  productList: {
    instrument: "Instrument",
    reagent: 'Reagent',
    software: 'Software'
  },

  Recruitment: {
    recruitment: 'Join Us',
    viewRequirements: 'View Job Requirements',
  },

  RecruitmentDetails: {
    jobResponsibilities: 'Job Responsibilities',
    qualifications: 'Qualifications',
    salaryAndBenefits: 'Salary and Benefits',
    resumeSubmissionPDF: 'Resume Submission (PDF)',
    submitted: 'Submitted',
    pdfOnly: 'Only PDF files are allowed!',
    fileSizeLimit: 'File size must not exceed 10MB!'
  },

  NewsCenter: {
    newsCenter: 'News Center',
    enterKeyword: 'Please enter a keyword',
  },

  ContactUs: {
    position: 'Position',
    company: 'Unit',
    unit: 'Unit',
    email: 'E-mail',
    phone: 'Phone',
    vx: 'WeChat',
    message: 'Message',
    submit: 'Submit',
    cancel: 'Cancel',
    reset: 'Reset',
    required: 'Required',
    minLength3: 'At least 3 characters required',
    enterEmail: 'Please enter your email',
    enterPhone: 'Please enter your phone number',
    invalidPhone: 'Invalid phone number format',
    cannotEmpty: 'Cannot be empty',
    submitted: 'Submitted Successfully',
    submitFailed: 'Submission Failed',
    allComments: 'All Comments',
    password: 'enter password',
    wrongPassword: 'wrong password',
    passwordCorrect: 'password correct',
  }


}



// WEBPACK FOOTER //
// ./src/i18n/locales/en-US.js